import * as ACTION_TYPES from './payrollActionTypes';

export const payrollReducerInitialState = {
	payrollListFilter:{}
};

export const payrollReducer = (state = payrollReducer, action) => {
	switch (action.type) {

		case ACTION_TYPES.SET_PAYROLL_LIST_FILTER: {
			const data = action.payload;
			return {
				...state,
				payrollListFilter: {
					...state.payrollListFilter,
					...data
				}
			}
		}

		default: {
			return state;
		}
	}
};


export const getPayrollReducer = state => state.payrollReducer;

//payroll list filter
export const getPayrollListFilter = state => getPayrollReducer(state)?.payrollListFilter;